export const defaultStrings = {
  appHeading: 'TgHunt — Find What You Want on Telegram',
  searchPlaceholder: 'Search for Telegram channels...',
  searchButton: 'Search',
  noResults: 'No results found',
  loading: 'Loading...',
  searchError: 'Search is temporarily unavailable.',
  accountLoadError: 'Unable to load your account.',
  billingError: 'Unable to create your payment link.',
  checkoutLoginTitle: 'Sign in to continue',
  checkoutLoginLead: 'Connect your Google account so we can create your secure payment invoice.',
  freeTier: 'FREE',
  upgrade: 'Upgrade',
  manageBilling: 'Billing',
  logout: 'Logout',
  login: 'Login',
  untitledChannel: 'Untitled channel',
  noDescription: 'No description available',
  subscribers: 'subscribers',
  loadMore: 'Load more',
  lockedLabel: 'Locked premium result',
  lockedCta: 'Unlock — $2.99/mo',
  premiumResultMessage: 'Unlock this premium channel — $2.99/mo',
  unlockFullResults: 'Unlock all {count} results — $2.99/mo',
  close: 'Close',
  manageProTitle: 'Manage TgHunt Pro',
  paywallTitle: 'Unlock Pro',
  manageProLead: 'Review your quota and current Pro access period.',
  paywallLead: 'Search more and unlock our premium search results.',
  proActiveStatus: 'Pro is active',
  priceAmount: '$2.99',
  every30Days: '/ month',
  proQuotaBenefit: '100 successful searches per 24 hours',
  proUnlockBenefit: 'Full results with every premium channel unlocked',
  invoiceBenefit: 'Pay securely with a card',
  quotaDetails: 'Quota details',
  quotaTier: 'Tier',
  quotaRemaining: 'Searches remaining',
  resetsIn: 'resets in',
  checkEmailStatus: 'Payment is pending. Access activates after you confirm.',
  accessUntil: 'Pro access until',
  working: 'Working...',
  emailPaymentLink: 'Subscribe — $2.99/mo',
  confirmPayment: "I've paid — unlock Pro",
  confirmPaymentHint: 'After you finish paying on Stripe, return here and confirm.',
  paymentNotFound: 'No paid checkout was found yet. Finish payment on Stripe, then confirm.',
  extendProAccess: 'Extend Pro access',
  billingFinePrint: 'Pro is $2.99 per month. Confirmed card payments are final.',
  proBillingFinePrint: 'You can resubscribe at any time. Confirmed card payments are final.',
  contactSupport: 'Contact Support',
  contactSupportSubject: 'TgHunt Support Request',
};
